import { Skeleton } from "@mui/material";

import styles from "./SkeletonCell.module.css";

/**
 * Cell content for a placeholder row. Decorative: the table's `aria-busy`
 * is what tells assistive tech it's loading.
 */
export function SkeletonCell() {
  return (
    <span className={styles.cell} aria-hidden="true">
      <Skeleton variant="rounded" animation="wave" className={styles.bar} />
    </span>
  );
}
